/* istanbul ignore file */

import TableProvider from "./components/TableProvider";
import Table from "./components/Table";
import {
  Button,
  ConfirmButton,
  ActionButton,
  DropdownButton
} from "./components/ActionButton";
import TableState from "./components/TableState";
import Settings from "./components/Settings";

export { useTableState } from "./hooks";

TableProvider.Table = Table;
TableProvider.Button = Button;
TableProvider.ConfirmButton = ConfirmButton;
TableProvider.ActionButton = ActionButton;
TableProvider.DropdownButton = DropdownButton;
TableProvider.TableState = TableState;
TableProvider.Settings = Settings;
export default TableProvider;
